export const colorTheme = {
  mainAccentColor: '#6446FF',
  paleAccentColor: '#BFC6FA',
  subAccentColor: '#5293FF',
  paleSubAccentColor: '#A5C6FC',
  deepRed: '#D35344',
  paleRed: '#FFEFED',
  pink: '#FF73CB',
  palePink: '#FFC9EE',
  blue: '#53ABF7',
  paleBlue: '#B6E1FF',
  green: '#01C99B',
  paleGreen: '#E2F6EF',
  deepYellow: '#D88435',
  paleYellow: '#FFF4E8',
  red900: '#FF402F',
  red600: '#FF6450',
  red200: '#FFA296',
  gray900: '#1B1D1F',
  gray600: '#454C53',
  gray400Cool: '#878EA1',
  gray400Warm: '#9EA4AA',
  gray200: '#C9CDD2',
  gray100: '#E8EBED',
  gray50: '#F7F8F9',
  background: '#EDF3FB',
};
